import "gijgo";
import "./gijgo-datepicker";

$('#contractor_expiration_date').datepicker({ showOnFocus: true, showRightIcon: false });
